import React, { Component } from "react";
import styled from "styled-components";
import InfoCard from "./InfoCard";
import baseStyles from "../../styles/baseStyles";
import Icon from "../UI/Icon";
import ChevronLeft from "../../assets/icons/chevron-left.svg";
import ChevronRight from "../../assets/icons/chevron-right.svg";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 140px;
`;

const Card = styled.div`
  background: #fff;
  box-shadow: ${baseStyles.layers.l5};
  border-radius: 10px;
  padding: 2rem;
  max-width: 30rem;
  height: 23rem;
  display: flex;
  flex-direction: column;
`;

const Chevron = styled(Icon)`
  cursor: pointer;
  fill: ${baseStyles.color.lightGray};
`;

class InfoCardCarousel extends Component {
  renderCountries = countries => {
    return countries.map(
      ({ id, name, description, icon: { url } }, index) =>
        this.props.selectedCountryIndex === index ? (
          <InfoCard key={id} name={name} description={description} url={url} />
        ) : null
    );
  };
  render() {
    return (
      <Wrapper>
        <Chevron
          iconRef={ChevronLeft}
          size={3}
          color={baseStyles.color.lightGray}
          onClick={() =>
            this.props.onCountryChange(this.props.selectedCountryIndex - 1)
          }
        />
        <Card>{this.renderCountries(this.props.countries)}</Card>
        <Chevron
          iconRef={ChevronRight}
          size={3}
          color={baseStyles.color.lightGray}
          onClick={() =>
            this.props.onCountryChange(this.props.selectedCountryIndex + 1)
          }
        />
      </Wrapper>
    );
  }
}

export default InfoCardCarousel;



// WEBPACK FOOTER //
// ./src/components/InfoCardCarousel/index.js